import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { get, set } from "firebase/database";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { userCountsRef } from "../firebase";

const pageLinks = [
    { path: "/calculate-shanten", title: "進張數計算", description: "手牌計算進張數" },
    { path: "/efficiency-trainer", title: "牌效率何切", description: "最大進張切牌練習" },
    { path: "/pure-ones-efficiency-trainer", title: "清一色何切", description: "清一色最大進張切牌練習" },
    { path: "/pure-ones-ready-trainer", title: "清一色聽牌", description: "清一色手牌聽牌練習" },
    { path: "/cut-300-trainer", title: "何切 300 問", description: "何切 300 問題庫練習" },
    { path: "/points-calculate-trainer", title: "點數計算", description: "飜符數的得點計算" },
    { path: "/aotenjiuu-calculate-trainer", title: "青天井計算", description: "青天井規則的得點計算" },
    { path: "/fu-calculate-trainer", title: "符數計算", description: "和牌手牌的符數計算" },
    { path: "/han-calculate-trainer", title: "飜數計算", description: "和牌手牌的飜數計算" },
    { path: "/hand-points-calculate-trainer", title: "手牌算點", description: "和牌手牌的得點計算" },
    { path: "/comments", title: "留言區", description: "看看其他人的留言" },
];

const MainPage = (props) => {
    const [userCounts, setUserCounts] = useState(null);
    const [contactOpen, setContactOpen] = useState(false);

    // 讀取使用者數量
    useEffect(() => {
        get(userCountsRef)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    setUserCounts(snapshot.val() + 1);
                    set(userCountsRef, snapshot.val() + 1);
                } else {
                    console.log("使用者數量變數不存在");
                }
            })
            .catch((error) => {
                console.error("取得使用者數量失敗:", error);
            });
    }, []);

    // 預加載圖片
    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/images.json`)
            .then((res) => res.json())
            .then((data) => {
                data.images.forEach((filename) => {
                    const img = new Image();
                    img.src = `${process.env.PUBLIC_URL}/images/${filename}`;
                });
            });
    }, []);

    return (
        <div
            style={{
                textAlign: "center",
                maxWidth: "90%",
                margin: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div style={{ color: "#007BFF", fontSize: "clamp(28px, 2vw, 32px)", fontWeight: "bold" }}>立直麻將練習網站</div>

            <Button size="small" variant="contained" onClick={() => setContactOpen(true)} style={{ fontSize: "14px", fontWeight: "bold", backgroundColor: "#007BFF", marginTop: "10px" }}>
                聯繫資訊
            </Button>

            {/* <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "15px",
                    justifyContent: "center",
                    marginTop: "15px",
                    gridAutoFlow: "row dense",
                }}
            >
                {pageLinks.map(({ path, title, description, img }, index) => {
                    const isLastSingle = pageLinks.length % 2 === 1 && index === pageLinks.length - 1;

                    return (
                        <Link
                            key={path}
                            to={path}
                            style={{
                                textDecoration: "none",
                                padding: "15px",
                                borderRadius: "10px",
                                border: "1px solid #007BFF",
                                color: "#007BFF",
                                transition: "background-color 0.3s, color 0.3s",
                                display: "block",
                                backgroundColor: "#f8f9fa",
                                textAlign: "center",
                                fontSize: "24px",
                                fontWeight: "bold",
                                cursor: "pointer",
                                position: "relative",
                                gridColumn: isLastSingle ? "span 2" : "auto",
                            }}
                        >
                            <div style={{ fontSize: "clamp(20px, 2vw, 24px)", fontWeight: "bold" }}>{title}</div>
                            {description && <p style={{ fontSize: "calc(0.8 * clamp(20px, 2vw, 24px))", fontWeight: "normal", margin: "10px 0 0" }}>{description}</p>}
                            <style>
                                {`
                                a:hover {
                                    background-color: #007BFF !important;
                                    color: #fff !important;
                                }
                                @media (max-width: 1024px) {
                                    div {
                                        grid-template-columns: repeat(2, 1fr);
                                    }
                                }
                                @media (max-width: 768px) {
                                    div {
                                        grid-template-columns: repeat(1, 1fr);
                                    }
                                }
                            `}
                            </style>
                        </Link>
                    );
                })}
            </div> */}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "20px",
                    marginTop: "20px",
                    padding: "0 16px",
                }}
            >
                {pageLinks.map(({ path, title, description }, index) => (
                    <Link
                        key={path}
                        to={path}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            padding: "20px 28px",
                            borderRadius: "20px",
                            border: "solid 1px #007BFF",
                            backgroundImage: "linear-gradient(145deg, #f0f4ff, #ffffff)",
                            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
                            textDecoration: "none",
                            color: "#007BFF",
                            transition: "all 0.1s ease-in-out",
                            position: "relative",
                            overflow: "hidden",
                            cursor: "pointer",
                            transform: "scale(1)",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.2)";
                            e.currentTarget.style.backgroundImage = "linear-gradient(145deg, #007BFF, #5b8dee)";
                            e.currentTarget.style.color = "#ffffff";
                            e.currentTarget.style.transform = "scale(1.03)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.2)";
                            e.currentTarget.style.backgroundImage = "linear-gradient(145deg, #f0f4ff, #ffffff)";
                            e.currentTarget.style.color = "#007BFF";
                            e.currentTarget.style.transform = "scale(1)";
                        }}
                    >
                        <div style={{ fontSize: "clamp(18px, 2vw, 22px)", fontWeight: 600, marginBottom: "8px" }}>{title}</div>
                        {description && <p style={{ fontSize: "calc(0.8 * clamp(18px, 2vw, 22px))", lineHeight: "1.4", opacity: 0.85, margin: 0 }}>{description}</p>}
                    </Link>
                ))}
                <style>
                    {`
                    @media (max-width: 400px) {
                        div[style*="display: grid"] {
                        grid-template-columns: 1fr !important;
                        }
                    }
                    `}
                </style>
            </div>

            <Box
                sx={{
                    textAlign: "center",
                    mt: 1,
                    p: 3,
                    backgroundColor: "background.default",
                    borderRadius: 2,
                }}
            >
                {userCounts && (
                    <Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
                        您是第{" "}
                        <Box component="span" sx={{ color: "primary.main", fontWeight: 700 }}>
                            {userCounts}
                        </Box>{" "}
                        個訪問本站的人
                    </Typography>
                )}
                <Typography variant="caption" sx={{ color: "text.secondary" }}>
                    v.1.5.5（最後更新：2025/8/2）
                </Typography>
            </Box>

            <Dialog open={contactOpen} onClose={() => setContactOpen(false)}>
                <DialogTitle>
                    聯繫資訊
                    <IconButton
                        aria-label="close"
                        onClick={() => setContactOpen(false)}
                        sx={{
                            position: "absolute",
                            right: 15,
                            top: 15,
                            color: (theme) => theme.palette.grey[700],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {[
                        {
                            icon: "gmail.png",
                            text: "tim6992481@gmail.com（推薦）",
                            href: "mailto:tim6992481@gmail.com",
                        },
                        {
                            icon: "bilibili.png",
                            text: "https://space.bilibili.com/386468729（請私信）",
                            href: "https://space.bilibili.com/386468729",
                        },
                        {
                            icon: "bahamut.png",
                            text: "https://forum.gamer.com.tw/C.php?bsn=36476&snA=3610",
                            href: "https://forum.gamer.com.tw/C.php?bsn=36476&snA=3610",
                        },
                    ].map(({ icon, text, href }) => (
                        <div key={href} style={{ display: "flex", alignItems: "center" }}>
                            <a href={href} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", textDecoration: "none", color: "inherit" }}>
                                <img src={`${process.env.PUBLIC_URL}/images/${icon}`} alt="icon" style={{ width: "50px", height: "50px", borderRadius: "20%", display: "block" }} />
                            </a>
                            <div style={{ marginLeft: "10px", fontSize: "14px" }}>{text}</div>
                        </div>
                    ))}
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default MainPage;
